import { reactive, watch } from "vue";
import { SazkaAlertProps } from "./models/sazka-alert-models";

export const sazkaAlertProps = reactive<SazkaAlertProps>({
    isOpen: false,
    title: "",
    text: "",
    ctaText: "Rozumím",
    ctaYellow: false,
    ctaFunction: null,
});

export default function sazkaAlert(
    title: string,
    text?: string,
    ctaText?: string,
    ctaYellow = false,
    ctaFunction?: () => void,
): Promise<void> {
    return new Promise<void>((resolve) => {
        sazkaAlertProps.title = title;
        sazkaAlertProps.text = text;
        sazkaAlertProps.ctaText = ctaText;
        sazkaAlertProps.ctaYellow = ctaYellow;
        sazkaAlertProps.ctaFunction = ctaFunction;

        sazkaAlertProps.isOpen = true;

        const watchStop = watch(
            () => sazkaAlertProps.isOpen,
            (newIsOpen) => {
                if (!newIsOpen) {
                    watchStop();
                    resolve();
                }
            },
        );
    });
}
